"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListOvertimeFilters = ListOvertimeFilters;
exports.SetIncomingPackageInClearOvertime = SetIncomingPackageInClearOvertime;
exports.SetIncomingPackageInWaitingResident = SetIncomingPackageInWaitingResident;
exports.changePackageCarrier = changePackageCarrier;
exports.changePackageLocation = changePackageLocation;
exports.createLocation = createLocation;
exports.createPackageBatch = createPackageBatch;
exports.deleteLocation = deleteLocation;
exports.deletePackage = deletePackage;
exports.forcePickup = forcePickup;
exports.get = get;
exports.list = list;
exports.listCarriers = listCarriers;
exports.listLocations = listLocations;
exports.listOvertimePackages = listOvertimePackages;
exports.listPackageMap = listPackageMap;
exports.listPackageTimeline = listPackageTimeline;
exports.packagesByCarrier = packagesByCarrier;
exports.packagesByDay = packagesByDay;
exports.packagesByState = packagesByState;
exports.packagesWatcher = packagesWatcher;
exports.patchPackage = patchPackage;
exports.returnPackage = returnPackage;
exports.undoReturnPackage = undoReturnPackage;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../variables");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _helpers = require("@qwkin/helpers");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(packagesWatcher);
function forcePickup(_ref) {
  var payload = _ref.payload,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? _helpers.identity : _ref$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.PackagesService.forceDelivery, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.FORCE_PICKUP_PACKAGE_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'All selected packages are now delivered'
            }
          });
        case 8:
          callback();
          _context.next = 19;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 16;
          return (0, _effects.put)({
            type: _variables.FORCE_PICKUP_PACKAGE_FAIL,
            payload: _response
          });
        case 16:
          _context.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 18:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  })();
}
function ListOvertimeFilters(_ref3) {
  var payload = _ref3.payload,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? _helpers.identity : _ref3$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _response$data3, response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.PackagesService.listIncomingPackageOvertimeFilters, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_OVERTIME_FILTERS_SUCCESS,
            payload: response
          });
        case 6:
          callback((_response$data3 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data3 !== void 0 ? _response$data3 : []);
          _context2.next = 17;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 14;
          return (0, _effects.put)({
            type: _variables.LIST_OVERTIME_FILTERS_FAIL,
            payload: _response2
          });
        case 14:
          _context2.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 16:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9]]);
  })();
}
function SetIncomingPackageInClearOvertime(_ref5) {
  var payload = _ref5.payload,
    _ref5$callback = _ref5.callback,
    callback = _ref5$callback === void 0 ? _helpers.identity : _ref5$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.PackagesService.setIncomingPackageInClearOvertime, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables.SET_IN_CLEAR_OVERTIME_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'All selected packages cleared successfully'
            }
          });
        case 8:
          callback();
          _context3.next = 19;
          break;
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 16;
          return (0, _effects.put)({
            type: _variables.SET_IN_CLEAR_OVERTIME_FAIL,
            payload: _response3
          });
        case 16:
          _context3.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 18:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 19:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 11]]);
  })();
}
function SetIncomingPackageInWaitingResident(_ref7) {
  var payload = _ref7.payload,
    _ref7$callback = _ref7.callback,
    callback = _ref7$callback === void 0 ? _helpers.identity : _ref7$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.PackagesService.setIncomingPackageInWaitingResident, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables.SET_IN_WAITING_RESIDENT_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'All selected packages are now waiting resident'
            }
          });
        case 8:
          callback();
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables.SET_IN_WAITING_RESIDENT_FAIL,
            payload: _response4
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function patchPackage(_ref9) {
  var payload = _ref9.payload,
    _ref9$callback = _ref9.callback,
    callback = _ref9$callback === void 0 ? _helpers.identity : _ref9$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.PackagesService.patchPackage, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables.PATCH_PACKAGE_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context5.next = 17;
          break;
        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](0);
          _response5 = _context5.t0.response;
          _context5.next = 14;
          return (0, _effects.put)({
            type: _variables.PATCH_PACKAGE_FAIL,
            payload: _response5
          });
        case 14:
          _context5.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 16:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 9]]);
  })();
}
function returnPackage(_ref11) {
  var payload = _ref11.payload,
    _ref11$callback = _ref11.callback,
    callback = _ref11$callback === void 0 ? _helpers.identity : _ref11$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var response, _response6$data, _response6$data2, _response6;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.PackagesService.returnPackage, payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables.RETURN_PACKAGE_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context6.next = 17;
          break;
        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](0);
          _response6 = _context6.t0.response;
          _context6.next = 14;
          return (0, _effects.put)({
            type: _variables.RETURN_PACKAGE_FAIL,
            payload: _response6
          });
        case 14:
          _context6.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response6$data = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data !== void 0 ? _response6$data : {}),
              data: _response6
            }
          });
        case 16:
          (0, _utils.logErr)((_response6$data2 = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data2 !== void 0 ? _response6$data2 : {});
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 9]]);
  })();
}
function listPackageMap(_ref13) {
  var payload = _ref13.payload,
    _ref13$callback = _ref13.callback,
    callback = _ref13$callback === void 0 ? _helpers.identity : _ref13$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var response, _response7$data, _response7$data2, _response7;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.PackagesService.listPackageMap, payload);
        case 3:
          response = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_PACKAGE_MAP_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context7.next = 17;
          break;
        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](0);
          _response7 = _context7.t0.response;
          _context7.next = 14;
          return (0, _effects.put)({
            type: _variables.LIST_PACKAGE_MAP_FAIL,
            payload: _response7
          });
        case 14:
          _context7.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response7$data = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data !== void 0 ? _response7$data : {}),
              data: _response7
            }
          });
        case 16:
          (0, _utils.logErr)((_response7$data2 = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data2 !== void 0 ? _response7$data2 : {});
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 9]]);
  })();
}
function createPackageBatch(_ref15) {
  var payload = _ref15.payload,
    _ref15$callback = _ref15.callback,
    callback = _ref15$callback === void 0 ? _helpers.identity : _ref15$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var response, _response8$data, _response8$data2, _response8;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.PackagesService.createPackageBatch, payload);
        case 3:
          response = _context8.sent;
          _context8.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_BATCH_PACKAGE_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context8.next = 17;
          break;
        case 9:
          _context8.prev = 9;
          _context8.t0 = _context8["catch"](0);
          _response8 = _context8.t0.response;
          _context8.next = 14;
          return (0, _effects.put)({
            type: _variables.CREATE_BATCH_PACKAGE_FAIL,
            payload: _response8
          });
        case 14:
          _context8.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response8$data = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data !== void 0 ? _response8$data : {}),
              data: _response8
            }
          });
        case 16:
          (0, _utils.logErr)((_response8$data2 = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data2 !== void 0 ? _response8$data2 : {});
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 9]]);
  })();
}
function undoReturnPackage(_ref17) {
  var payload = _ref17.payload,
    _ref17$callback = _ref17.callback,
    callback = _ref17$callback === void 0 ? _helpers.identity : _ref17$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var response, _response9$data, _response9$data2, _response9;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.PackagesService.undoReturnPackage, payload);
        case 3:
          response = _context9.sent;
          _context9.next = 6;
          return (0, _effects.put)({
            type: _variables.UNDO_RETURN_PACKAGE_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context9.next = 17;
          break;
        case 9:
          _context9.prev = 9;
          _context9.t0 = _context9["catch"](0);
          _response9 = _context9.t0.response;
          _context9.next = 14;
          return (0, _effects.put)({
            type: _variables.UNDO_RETURN_PACKAGE_FAIL,
            payload: _response9
          });
        case 14:
          _context9.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response9$data = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data !== void 0 ? _response9$data : {}),
              data: _response9
            }
          });
        case 16:
          (0, _utils.logErr)((_response9$data2 = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data2 !== void 0 ? _response9$data2 : {});
        case 17:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 9]]);
  })();
}
function get(_ref19) {
  var payload = _ref19.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
    var response, _response10$data, _response10$data2, _response10;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.PackagesService.getPackageById, payload);
        case 3:
          response = _context10.sent;
          _context10.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_PACKAGE_SUCCESS,
            payload: response
          });
        case 6:
          _context10.next = 16;
          break;
        case 8:
          _context10.prev = 8;
          _context10.t0 = _context10["catch"](0);
          _response10 = _context10.t0.response;
          _context10.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_PACKAGE_FAIL,
            payload: _response10
          });
        case 13:
          _context10.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response10$data = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data !== void 0 ? _response10$data : {}),
              data: _response10
            }
          });
        case 15:
          (0, _utils.logErr)((_response10$data2 = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data2 !== void 0 ? _response10$data2 : {});
        case 16:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 8]]);
  })();
}
function list(_ref21) {
  var payload = _ref21.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
    var response, _response11$data, _response11$data2, _response11;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_services.PackagesService.listPackages, payload);
        case 3:
          response = _context11.sent;
          _context11.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_PACKAGES_SUCCESS,
            payload: response
          });
        case 6:
          _context11.next = 16;
          break;
        case 8:
          _context11.prev = 8;
          _context11.t0 = _context11["catch"](0);
          _response11 = _context11.t0.response;
          _context11.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_PACKAGES_FAIL,
            payload: _response11
          });
        case 13:
          _context11.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response11$data = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data !== void 0 ? _response11$data : {}),
              data: _response11
            }
          });
        case 15:
          (0, _utils.logErr)((_response11$data2 = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data2 !== void 0 ? _response11$data2 : {});
        case 16:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 8]]);
  })();
}
function listPackageTimeline(_ref23) {
  var payload = _ref23.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
    var response, _response12$data, _response12$data2, _response12;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.PackagesService.listPackageTimeline, payload);
        case 3:
          response = _context12.sent;
          _context12.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_PACKAGE_TIMELINE_SUCCESS,
            payload: response
          });
        case 6:
          _context12.next = 16;
          break;
        case 8:
          _context12.prev = 8;
          _context12.t0 = _context12["catch"](0);
          _response12 = _context12.t0.response;
          _context12.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_PACKAGE_TIMELINE_FAIL,
            payload: _response12
          });
        case 13:
          _context12.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response12$data = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data !== void 0 ? _response12$data : {}),
              data: _response12
            }
          });
        case 15:
          (0, _utils.logErr)((_response12$data2 = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data2 !== void 0 ? _response12$data2 : {});
        case 16:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 8]]);
  })();
}
function listCarriers(_ref25) {
  var payload = _ref25.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
    var response, _response13$data, _response13$data2, _response13;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.PackagesService.listCarriers, payload);
        case 3:
          response = _context13.sent;
          _context13.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_CARRIERS_SUCCESS,
            payload: response
          });
        case 6:
          _context13.next = 16;
          break;
        case 8:
          _context13.prev = 8;
          _context13.t0 = _context13["catch"](0);
          _response13 = _context13.t0.response;
          _context13.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_CARRIERS_FAIL,
            payload: _response13
          });
        case 13:
          _context13.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response13$data = _response13 === null || _response13 === void 0 ? void 0 : _response13.data) !== null && _response13$data !== void 0 ? _response13$data : {}),
              data: _response13
            }
          });
        case 15:
          (0, _utils.logErr)((_response13$data2 = _response13 === null || _response13 === void 0 ? void 0 : _response13.data) !== null && _response13$data2 !== void 0 ? _response13$data2 : {});
        case 16:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 8]]);
  })();
}
function listOvertimePackages(_ref27) {
  var payload = _ref27.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
    var response, _response14$data, _response14$data2, _response14;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          payload.overtime = 'onlyOvertimed';
          _context14.next = 4;
          return (0, _effects.call)(_services.PackagesService.listPackages, payload);
        case 4:
          response = _context14.sent;
          _context14.next = 7;
          return (0, _effects.put)({
            type: _variables.LIST_OVERTIME_PACKAGES_SUCCESS,
            payload: response
          });
        case 7:
          _context14.next = 17;
          break;
        case 9:
          _context14.prev = 9;
          _context14.t0 = _context14["catch"](0);
          _response14 = _context14.t0.response;
          _context14.next = 14;
          return (0, _effects.put)({
            type: _variables.LIST_OVERTIME_PACKAGES_FAIL,
            payload: _response14
          });
        case 14:
          _context14.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response14$data = _response14 === null || _response14 === void 0 ? void 0 : _response14.data) !== null && _response14$data !== void 0 ? _response14$data : {}),
              data: _response14
            }
          });
        case 16:
          (0, _utils.logErr)((_response14$data2 = _response14 === null || _response14 === void 0 ? void 0 : _response14.data) !== null && _response14$data2 !== void 0 ? _response14$data2 : {});
        case 17:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 9]]);
  })();
}
function listLocations(_ref29) {
  var payload = _ref29.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
    var response, _response15$data, _response15$data2, _response15;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.PackagesService.listLocations, payload);
        case 3:
          response = _context15.sent;
          _context15.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_LOCATIONS_SUCCESS,
            payload: response
          });
        case 6:
          _context15.next = 16;
          break;
        case 8:
          _context15.prev = 8;
          _context15.t0 = _context15["catch"](0);
          _response15 = _context15.t0.response;
          _context15.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_LOCATIONS_FAIL,
            payload: _response15
          });
        case 13:
          _context15.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response15$data = _response15 === null || _response15 === void 0 ? void 0 : _response15.data) !== null && _response15$data !== void 0 ? _response15$data : {}),
              data: _response15
            }
          });
        case 15:
          (0, _utils.logErr)((_response15$data2 = _response15 === null || _response15 === void 0 ? void 0 : _response15.data) !== null && _response15$data2 !== void 0 ? _response15$data2 : {});
        case 16:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 8]]);
  })();
}
function changePackageLocation(_ref31) {
  var payload = _ref31.payload,
    _ref31$callback = _ref31.callback,
    callback = _ref31$callback === void 0 ? _helpers.identity : _ref31$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
    var response, _response16$data, _response16$data2, _response16;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.call)(_services.PackagesService.changePackageLocation, payload);
        case 3:
          response = _context16.sent;
          _context16.next = 6;
          return (0, _effects.put)({
            type: _variables.CHANGE_PACKAGE_LOCATION_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context16.next = 17;
          break;
        case 9:
          _context16.prev = 9;
          _context16.t0 = _context16["catch"](0);
          _response16 = _context16.t0.response;
          _context16.next = 14;
          return (0, _effects.put)({
            type: _variables.CHANGE_PACKAGE_LOCATION_FAIL,
            payload: _response16
          });
        case 14:
          _context16.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response16$data = _response16 === null || _response16 === void 0 ? void 0 : _response16.data) !== null && _response16$data !== void 0 ? _response16$data : {}),
              data: _response16
            }
          });
        case 16:
          (0, _utils.logErr)((_response16$data2 = _response16 === null || _response16 === void 0 ? void 0 : _response16.data) !== null && _response16$data2 !== void 0 ? _response16$data2 : {});
        case 17:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 9]]);
  })();
}
function changePackageCarrier(_ref33) {
  var payload = _ref33.payload,
    _ref33$callback = _ref33.callback,
    callback = _ref33$callback === void 0 ? _helpers.identity : _ref33$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
    var response, _response17$data, _response17$data2, _response17;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return (0, _effects.call)(_services.PackagesService.changePackageCarrier, payload);
        case 3:
          response = _context17.sent;
          _context17.next = 6;
          return (0, _effects.put)({
            type: _variables.CHANGE_PACKAGE_CARRIER_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context17.next = 17;
          break;
        case 9:
          _context17.prev = 9;
          _context17.t0 = _context17["catch"](0);
          _response17 = _context17.t0.response;
          _context17.next = 14;
          return (0, _effects.put)({
            type: _variables.CHANGE_PACKAGE_CARRIER_FAIL,
            payload: _response17
          });
        case 14:
          _context17.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response17$data = _response17 === null || _response17 === void 0 ? void 0 : _response17.data) !== null && _response17$data !== void 0 ? _response17$data : {}),
              data: _response17
            }
          });
        case 16:
          (0, _utils.logErr)((_response17$data2 = _response17 === null || _response17 === void 0 ? void 0 : _response17.data) !== null && _response17$data2 !== void 0 ? _response17$data2 : {});
        case 17:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[0, 9]]);
  })();
}
function createLocation(_ref35) {
  var payload = _ref35.payload,
    _ref35$callback = _ref35.callback,
    callback = _ref35$callback === void 0 ? _helpers.identity : _ref35$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee18() {
    var response, _response18$data, _response18$data2, _response18;
    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return (0, _effects.call)(_services.PackagesService.createPackageLocation, payload);
        case 3:
          response = _context18.sent;
          _context18.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_LOCATION_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context18.next = 17;
          break;
        case 9:
          _context18.prev = 9;
          _context18.t0 = _context18["catch"](0);
          _response18 = _context18.t0.response;
          _context18.next = 14;
          return (0, _effects.put)({
            type: _variables.CREATE_LOCATION_FAIL,
            payload: _response18
          });
        case 14:
          _context18.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response18$data = _response18 === null || _response18 === void 0 ? void 0 : _response18.data) !== null && _response18$data !== void 0 ? _response18$data : {}),
              data: _response18
            }
          });
        case 16:
          (0, _utils.logErr)((_response18$data2 = _response18 === null || _response18 === void 0 ? void 0 : _response18.data) !== null && _response18$data2 !== void 0 ? _response18$data2 : {});
        case 17:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[0, 9]]);
  })();
}
function deleteLocation(_ref37) {
  var payload = _ref37.payload,
    _ref37$callback = _ref37.callback,
    callback = _ref37$callback === void 0 ? _helpers.identity : _ref37$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
    var response, _response19$data, _response19$data2, _response19;
    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.prev = 0;
          _context19.next = 3;
          return (0, _effects.call)(_services.PackagesService.deletePackageLocation, payload);
        case 3:
          response = _context19.sent;
          _context19.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_LOCATION_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context19.next = 17;
          break;
        case 9:
          _context19.prev = 9;
          _context19.t0 = _context19["catch"](0);
          _response19 = _context19.t0.response;
          _context19.next = 14;
          return (0, _effects.put)({
            type: _variables.DELETE_LOCATION_FAIL,
            payload: _response19
          });
        case 14:
          _context19.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response19$data = _response19 === null || _response19 === void 0 ? void 0 : _response19.data) !== null && _response19$data !== void 0 ? _response19$data : {}),
              data: _response19
            }
          });
        case 16:
          (0, _utils.logErr)((_response19$data2 = _response19 === null || _response19 === void 0 ? void 0 : _response19.data) !== null && _response19$data2 !== void 0 ? _response19$data2 : {});
        case 17:
        case "end":
          return _context19.stop();
      }
    }, _callee19, null, [[0, 9]]);
  })();
}
function deletePackage(_ref39) {
  var payload = _ref39.payload,
    _ref39$callback = _ref39.callback,
    callback = _ref39$callback === void 0 ? _helpers.identity : _ref39$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee20() {
    var response, _response20$data, _response20$data2, _response20;
    return _regenerator["default"].wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return (0, _effects.call)(_services.PackagesService.deletePackage, payload);
        case 3:
          response = _context20.sent;
          _context20.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_PACKAGE_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context20.next = 17;
          break;
        case 9:
          _context20.prev = 9;
          _context20.t0 = _context20["catch"](0);
          _response20 = _context20.t0.response;
          _context20.next = 14;
          return (0, _effects.put)({
            type: _variables.DELETE_PACKAGE_FAIL,
            payload: _response20
          });
        case 14:
          _context20.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response20$data = _response20 === null || _response20 === void 0 ? void 0 : _response20.data) !== null && _response20$data !== void 0 ? _response20$data : {}),
              data: _response20
            }
          });
        case 16:
          (0, _utils.logErr)((_response20$data2 = _response20 === null || _response20 === void 0 ? void 0 : _response20.data) !== null && _response20$data2 !== void 0 ? _response20$data2 : {});
        case 17:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[0, 9]]);
  })();
}
function packagesByCarrier(_ref41) {
  var payload = _ref41.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
    var response, _response21$data, _response21$data2, _response21;
    return _regenerator["default"].wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.prev = 0;
          _context21.next = 3;
          return (0, _effects.call)(_services.PackagesService.incomingPackagesByCarrier, payload);
        case 3:
          response = _context21.sent;
          _context21.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_PACKAGES_BY_CARRIER_SUCCESS,
            payload: response
          });
        case 6:
          _context21.next = 16;
          break;
        case 8:
          _context21.prev = 8;
          _context21.t0 = _context21["catch"](0);
          _response21 = _context21.t0.response;
          _context21.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_PACKAGES_BY_CARRIER_FAIL,
            payload: _response21
          });
        case 13:
          _context21.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response21$data = _response21 === null || _response21 === void 0 ? void 0 : _response21.data) !== null && _response21$data !== void 0 ? _response21$data : {}),
              data: _response21
            }
          });
        case 15:
          (0, _utils.logErr)((_response21$data2 = _response21 === null || _response21 === void 0 ? void 0 : _response21.data) !== null && _response21$data2 !== void 0 ? _response21$data2 : {});
        case 16:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[0, 8]]);
  })();
}
function packagesByDay(_ref43) {
  var payload = _ref43.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
    var response, _response22$data, _response22$data2, _response22;
    return _regenerator["default"].wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.prev = 0;
          _context22.next = 3;
          return (0, _effects.call)(_services.PackagesService.incomingPackagesByDay, payload);
        case 3:
          response = _context22.sent;
          _context22.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_PACKAGES_BY_DAY_SUCCESS,
            payload: response
          });
        case 6:
          _context22.next = 16;
          break;
        case 8:
          _context22.prev = 8;
          _context22.t0 = _context22["catch"](0);
          _response22 = _context22.t0.response;
          _context22.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_PACKAGES_BY_DAY_FAIL,
            payload: _response22
          });
        case 13:
          _context22.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response22$data = _response22 === null || _response22 === void 0 ? void 0 : _response22.data) !== null && _response22$data !== void 0 ? _response22$data : {}),
              data: _response22
            }
          });
        case 15:
          (0, _utils.logErr)((_response22$data2 = _response22 === null || _response22 === void 0 ? void 0 : _response22.data) !== null && _response22$data2 !== void 0 ? _response22$data2 : {});
        case 16:
        case "end":
          return _context22.stop();
      }
    }, _callee22, null, [[0, 8]]);
  })();
}
function packagesByState(_ref45) {
  var payload = _ref45.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
    var response, _response23$data, _response23$data2, _response23;
    return _regenerator["default"].wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          _context23.next = 3;
          return (0, _effects.call)(_services.PackagesService.incomingPackagesByState, payload);
        case 3:
          response = _context23.sent;
          _context23.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_PACKAGES_BY_STATE_SUCCESS,
            payload: response
          });
        case 6:
          _context23.next = 16;
          break;
        case 8:
          _context23.prev = 8;
          _context23.t0 = _context23["catch"](0);
          _response23 = _context23.t0.response;
          _context23.next = 13;
          return (0, _effects.put)({
            type: _variables.GET_PACKAGES_BY_STATE_FAIL,
            payload: _response23
          });
        case 13:
          _context23.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response23$data = _response23 === null || _response23 === void 0 ? void 0 : _response23.data) !== null && _response23$data !== void 0 ? _response23$data : {}),
              data: _response23
            }
          });
        case 15:
          (0, _utils.logErr)((_response23$data2 = _response23 === null || _response23 === void 0 ? void 0 : _response23.data) !== null && _response23$data2 !== void 0 ? _response23$data2 : {});
        case 16:
        case "end":
          return _context23.stop();
      }
    }, _callee23, null, [[0, 8]]);
  })();
}
function packagesWatcher() {
  return _regenerator["default"].wrap(function packagesWatcher$(_context24) {
    while (1) switch (_context24.prev = _context24.next) {
      case 0:
        _context24.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.LIST_PACKAGES_REQUEST, list), (0, _effects.takeLatest)(_variables.LIST_PACKAGE_MAP_REQUEST, listPackageMap), (0, _effects.takeLatest)(_variables.LIST_CARRIERS_REQUEST, listCarriers), (0, _effects.takeLatest)(_variables.PATCH_PACKAGE_REQUEST, patchPackage), (0, _effects.takeLatest)(_variables.LIST_OVERTIME_PACKAGES_REQUEST, listOvertimePackages), (0, _effects.takeLatest)(_variables.GET_PACKAGE_REQUEST, get), (0, _effects.takeLatest)(_variables.LIST_LOCATIONS_REQUEST, listLocations), (0, _effects.takeLatest)(_variables.CREATE_LOCATION_REQUEST, createLocation), (0, _effects.takeLatest)(_variables.DELETE_LOCATION_REQUEST, deleteLocation), (0, _effects.takeLatest)(_variables.CHANGE_PACKAGE_LOCATION_REQUEST, changePackageLocation), (0, _effects.takeLatest)(_variables.CHANGE_PACKAGE_CARRIER_REQUEST, changePackageCarrier), (0, _effects.takeLatest)(_variables.RETURN_PACKAGE_REQUEST, returnPackage), (0, _effects.takeLatest)(_variables.UNDO_RETURN_PACKAGE_REQUEST, undoReturnPackage), (0, _effects.takeLatest)(_variables.DELETE_PACKAGE_REQUEST, deletePackage), (0, _effects.takeLatest)(_variables.FORCE_PICKUP_PACKAGE_REQUEST, forcePickup), (0, _effects.takeLatest)(_variables.CREATE_BATCH_PACKAGE_REQUEST, createPackageBatch), (0, _effects.takeLatest)(_variables.LIST_PACKAGE_TIMELINE_REQUEST, listPackageTimeline), (0, _effects.takeLatest)(_variables.GET_PACKAGES_BY_CARRIER_REQUEST, packagesByCarrier), (0, _effects.takeLatest)(_variables.GET_PACKAGES_BY_DAY_REQUEST, packagesByDay), (0, _effects.takeLatest)(_variables.GET_PACKAGES_BY_STATE_REQUEST, packagesByState), (0, _effects.takeLatest)(_variables.LIST_OVERTIME_FILTERS_REQUEST, ListOvertimeFilters), (0, _effects.takeLatest)(_variables.SET_IN_CLEAR_OVERTIME_REQUEST, SetIncomingPackageInClearOvertime), (0, _effects.takeLatest)(_variables.SET_IN_WAITING_RESIDENT_REQUEST, SetIncomingPackageInWaitingResident)]);
      case 2:
      case "end":
        return _context24.stop();
    }
  }, _marked);
}